<template>
  <div class="consumer-extra-offers">
    <div class="row" v-if="consumerLoaded && offersloaded">
      <div class="col-8">
        <OfferManager :offers="offers" :submitted-offers="successfulSubmitIds" :successful-offers="successfulSubmits" :pending-submits="pendingSubmits" :pending-offers="pendingOffers" :wait="wait" :loading="loadingOffers" @submit-offer="submitOffer" @expired="expired" @skip-offer="skipOffer" @refresh-offers="reload" :extra-only="true"></OfferManager>
      </div>
      <div class="col-4">
        <RightOffersPanel :skipped-offers="skipped" @unskipOffer="unskipOffer" :extra-only="true"></RightOffersPanel>
      </div>
    </div>
    <div class="row loading-row" v-if="!consumerLoaded || !offersloaded">
      <div class="loading-text">Please wait as we are processing the information.</div>
      <img :src="loadingImg" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import PortalFetchJson from '@/js/PortalFetchJson'
import PortalPostJson from '@/js/PortalPostJson'
import OfferManager from '@/components/OfferManager.vue'
import RightOffersPanel from '@/components/RightOffersPanel.vue'

export default {
  name: 'ConsumerExtraOffers',
  props: ['consumerId'],
  components: {
    OfferManager,
    RightOffersPanel
  },
  data () {
    return {
      allOffers: [],
      skippedOffers: [],
      offersloaded: false,
      loadingOffers: false,
      wait: false,
      loadingImg: process.env.BASE_URL + 'loading.gif'
    }
  },
  methods: {
    loadConsumerOrContinue (id) {
      this.validateConsumer()
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      } else {
        this.load()
      }
    },
    load () {
      if (!this.offersloaded && !this.loadingOffers) {
        this.loadOffers()
      }
    },
    async expired (offerInfo) {
      var offer = this.allOffers.find((offer) => offer.displayedOfferId === offerInfo.displayedOfferId)
      if (!this.loadingOffers && !offer.newOffer) {
        this.reSearchOffers(offerInfo, true)
      }
    },
    async reSearchOffers (offerInfo, expired) {
      this.waitOnOffers()
      var offerResponse = await PortalFetchJson(`timed_out_offer_searches?consumer_id=${this.consumerId}&offer_id=${offerInfo.offerId}`)
      if (!expired) {
        this.searchRequestInfo = { request_keys: offerResponse.request_keys, offers: offerResponse.extra_offers }
      }
      this.processOfferResponse(offerResponse, true)
      var offerIndex = this.allOffers.findIndex((offer) => offer.displayedOfferId === offerInfo.displayedOfferId)
      this.allOffers.splice(offerIndex, 1)
      this.finishLoadingOffers()
    },
    reload () {
      if (!this.loadingOffers) {
        this.allOffers = []
        this.offersloaded = false
        this.loadOffers()
      }
    },
    async loadOffers () {
      this.loadingOffers = true
      var offerResponse = await PortalFetchJson(`offers?consumer_id=${this.consumerId}&agent_id=${this.consumer.agent_id}&dialer_session_id=${this.consumer.dialer_session_id ?? ''}&subid=${this.consumer.subid ?? ''}&subid2=${this.consumer.subid2 ?? ''}&subid3=${this.consumer.subid3 ?? ''}&subid4=${this.consumer.subid4 ?? ''}&pub_transaction_id=${this.consumer.pub_transaction_id ?? ''}&extra_only=true`)
      this.processOfferResponse(offerResponse)
      this.offersloaded = true
      this.finishLoadingOffers()
    },
    finishLoadingOffers () {
      if (this.allOffers.length < 1) {
        if (this.previousSubmits.length > 0) {
          this.$router.push(`/consumer/${this.consumerId}/success`)
        } else {
          this.$router.push(`/consumer/${this.consumerId}/no-offers`)
        }
      }
      this.loadingOffers = false
    },
    processOfferResponse (offerResponse) {
      var responseTime = Date.now()
      var offers = offerResponse.offers || offerResponse.extra_offers
      offers.forEach((offer) => {
        if (this.previousSubmits.some((submit) => (submit.offer.id === offer.id || submit.offer.id === offer.offer_id) && (submit.externalNameId === offer.offer_external_name_ids ||
          (Array.isArray(submit.externalNameId) && Array.isArray(offer.offer_external_name_ids) && submit.externalNameId.some((eni) => offer.offer_external_name_ids.includes(eni)))))) {
          return
        }
        var formattedOffer = {
          id: offer.offer_id ?? offer.id,
          name: offer.name,
          campaignId: offer.campaign_id,
          displayId: offer.display_offer_id,
          division: offer.division,
          exclusive: offer.exclusive,
          formId: offer.form_id,
          isWt: offer.is_warm_transfer,
          logoURL: offer.logo_url,
          shortDescription: offer.short_description,
          longDescription: offer.long_description,
          offerType: offer.offer_type,
          sequence: offer.sequence,
          offerExternalNameId: offer.offer_external_name_id,
          externalNameId: Array.isArray(offer.offer_external_name_ids) ? offer.offer_external_name_ids : [offer.offer_external_name_ids],
          externalNameInclusiveOfferId: offer.offer_external_name_inclusive_offer_id,
          offerExternalInfoId: offer.offer_external_info_id,
          expiresAt: offer.expires_in ? responseTime + offer.expires_in : false,
          displayedOfferId: offer.displayed_offer_id,
          isExternalApi: !offerResponse.offers,
          priority: offer.priority,
          pingOnShow: offer.ping_on_show
        }
        if (offer.division === 2) {
          formattedOffer.isExtra = true
        }
        if (!offer.form_id) {
          var formFields = offer.form_field_ids.map((id) => offerResponse.form_fields.find((field) => field.id === id))
          formattedOffer.formFields = formFields
          formattedOffer.formListItems = offerResponse.form_list_items.filter((item) => formFields.some((field) => field.form_list_item_ids.includes(item.id)))
        }
        formattedOffer.programs = []
        formattedOffer.subjects = []
        offerResponse.programs.forEach((program, index) => {
          if (offer.program_ids.includes(program.id) && offerResponse.programs.findIndex((p) => p.id === program.id) === index) {
            formattedOffer.programs.push(program)
            if (program.subject_id && !formattedOffer.subjects.some((subject) => subject.id === program.subject_id)) {
              formattedOffer.subjects.push(offerResponse.subjects.find((subject) => subject.id === program.subject_id))
            }
          }
        })
        formattedOffer.campuses = offerResponse.campuses.filter((campus, index) => offer.campus_ids.includes(campus.id) && offerResponse.campuses.findIndex((c) => c.id === campus.id) === index)
        formattedOffer.schoolType = formattedOffer.campuses.some((campus) => campus.school_type_id === 1)
          ? formattedOffer.campuses.some((campus) => campus.school_type_id === 2) ? 'both' : 'online' : 'campus'
        if (offer.is_warm_transfer) {
          formattedOffer.wtId = offer.warm_transfer_id
          formattedOffer.wtScript = offerResponse.warm_transfers ? offerResponse.warm_transfers.find((wt) => wt.id === offer.warm_transfer_id).script : null
        }

        var skippedIndex = this.skippedOffers.findIndex((skipped) => skipped.externalNameId === formattedOffer.externalNameId && skipped.id === formattedOffer.id)
        if (skippedIndex >= 0) {
          this.skippedOffers.splice(skippedIndex, 1, formattedOffer)
        } else {
          this.allOffers.push(formattedOffer)
        }
      })
    },
    async submitOffer (submitObject) {
      submitObject.leadRequest.consumer_id = this.loadedId
      var wrappedRequest = {
        lead_request: submitObject.leadRequest
      }
      var offerIndex = this.allOffers.findIndex((offer) => offer.id === submitObject.offer.id && offer.displayedOfferId === submitObject.offer.displayedOfferId)
      if (this.successfulSubmitIds.length + this.pendingSubmits.length > this.consumer.max_offer_submission - 2 || submitObject.offer.isWt || submitObject.offer.exclusive) {
        this.wait = true
      }
      this.addPendingLeadRequest(submitObject.offer)
      this.allOffers.splice(offerIndex, 1)
      var results = await PortalPostJson('lead_requests', wrappedRequest)
      var campus = submitObject.offer.campuses.find((campus) => campus.id === submitObject.leadRequest.raw_request.lead_education.campus_id)
      var program = submitObject.offer.programs.find((program) => program.id === submitObject.leadRequest.raw_request.lead_education.program_id)
      var submittedOffer = {
        offer: submitObject.offer,
        offerId: submitObject.offer.id,
        externalNameId: Array.isArray(submitObject.offer.externalNameId) ? submitObject.offer.externalNameId : [submitObject.offer.externalNameId],
        externalNameInclusiveOfferId: submitObject.offer.externalNameInclusiveOfferId,
        offerExternalNameId: submitObject.offer.offerExternalNameId,
        campusName: campus === undefined ? '' : campus.name,
        programName: program === undefined ? '' : program.name,
        status: results.errors ? 'Rejected' : results.lead_request.status,
        errors: results.errors
      }
      this.removePendingLeadRequest(submitObject.offer)
      this.addLeadRequest(submittedOffer)
      this.wait = false
      if (this.consumer.max_offer_submission === this.successfulSubmitIds.length || (submittedOffer.status !== 'Rejected' && (submittedOffer.offer.isWt || submittedOffer.offer.exclusive)) || this.allOffers.length < 1) {
        this.$router.push(`/consumer/${this.consumerId}/success`)
      }
    },
    skipOffer (skipInfo) {
      var offerIndex = this.allOffers.findIndex((offer) => offer.displayedOfferId === skipInfo.displayedOfferId)
      var skipped = this.allOffers.splice(offerIndex, 1)[0]
      skipped.skipReason = skipInfo.reason
      this.skippedOffers.push(skipped)
      if (this.allOffers.length < 1) {
        if (this.previousSubmits.length > 0) {
          this.$router.push(`/consumer/${this.consumerId}/success`)
        } else {
          this.$router.push(`/consumer/${this.consumerId}/no-offers`)
        }
      }
    },
    unskipOffer (skippedOffer) {
      var offerIndex = this.skippedOffers.findIndex((offer) => offer.displayedOfferId === skippedOffer.displayedOfferId)
      this.skippedOffers.splice(offerIndex, 1)
      this.allOffers.push(skippedOffer)
    },
    async validateConsumer () {
      var validationResults = await PortalFetchJson(`consumer_validations?consumer_id=${this.consumerId}`)
      if (!validationResults.consumer_validation.valid) {
        validationResults.consumer_validation.error_messages.forEach((error) => {
          this.addConsumerError({ type: 'HiddenFieldError', field: error.field, errorMsg: error.message })
        })
        this.$router.push(`/consumer/${this.consumerId}/not-valid`)
      }
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    }),
    ...mapMutations({
      addLeadRequest: 'consumer/leadRequests/addLeadRequest',
      addPendingLeadRequest: 'consumer/leadRequests/addPendingLeadRequest',
      removePendingLeadRequest: 'consumer/leadRequests/removePendingLeadRequest',
      addConsumerError: 'consumer/addConsumerError'
    })
  },
  computed: {
    successfulSubmits () {
      return [...this.previousSubmits.filter((submit) => submit.status === 'Accepted' && submit.externalNameId)]
    },
    successfulSubmitIds () {
      return [...this.previousSubmits.filter((submit) => submit.status === 'Accepted' && submit.externalNameId).map((submit) => submit.externalNameId)]
    },
    offers () {
      return {
        warmTransfer: this.allOffers.filter((offer) => offer.isWt && !offer.isExtra),
        callVerified: this.allOffers.filter((offer) => !offer.isWt && !offer.isExtra),
        extra: this.allOffers.filter((offer) => offer.isExtra)
      }
    },
    skipped () {
      return {
        warmTransfer: this.skippedOffers.filter((offer) => offer.isWt && !offer.isExtra),
        callVerified: this.skippedOffers.filter((offer) => !offer.isWt && !offer.isExtra),
        extra: this.skippedOffers.filter((offer) => offer.isExtra)
      }
    },
    needsAreaOfStudy () {
      return this.consumer.show_area_study_page && !this.subjectsSelected
    },
    allSubjectIds () {
      if (this.consumer) {
        return this.subjectIds ? [...this.subjectIds, ...this.consumer.default_area_studies] : [...this.consumer.default_area_studies]
      }
      return []
    },
    pendingOffers () {
      return [...this.pendingLeadRequests]
    },
    pendingSubmits () {
      return [...this.pendingLeadRequests.map((plr) => plr.externalNameId)]
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      consumer: state => state.consumer.currentConsumer,
      subjectIds: state => state.consumer.additionalInfo.info.subject_ids,
      leadRequestsFull: state => state.consumer.leadRequests.leadRequestsFull,
      pendingLeadRequests: state => state.consumer.leadRequests.pendingLeadRequests
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      previousSubmits: 'consumer/leadRequests/getRequests'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.loadConsumerOrContinue(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.loadConsumerOrContinue(val)
    },
    loadedId () {
      this.load()
      if (this.leadRequestsFull) {
        this.$router.push(`/consumer/${this.consumerId}/success`)
      }
    }
  }
}
</script>

<style scoped>
.loading-row {
  padding-top: 150px;
}
.loading-row img {
  height: 70px;
  width: auto;
  margin: auto;
}
.loading-text {
  text-align: center;
  margin: auto;
}
</style>
<style>
.offer-subject {
  height: fit-content;
  background-color: #5bc0de;
  color: white;
  border-radius: .25em;
  margin-right: 4px;
  margin-top: 2px;
  font-weight: 600;
  font-size: 10.5px;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
